import { variables } from '../common/variables';

import { cl } from '../common/functions';

const resetLocation = (map, group) => {
  const leafletControlContainer = document.querySelector('.leaflet-top.leaflet-left');
  if (leafletControlContainer) {
    const resetLocationElement = `<div class="leaflet-control-resetLocation leaflet-bar leaflet-control">
    <a class="leaflet-control-resetLocation-button leaflet-bar-part" title="vue globale"></a>
    </div>`;
    leafletControlContainer.insertAdjacentHTML('beforeend', resetLocationElement);
    const resetLocationButton = document.querySelector('.leaflet-control-resetLocation-button');
    if (resetLocationButton) {
      // prettier-ignore
      resetLocationButton.addEventListener('click', () => {
        map.fitBounds(group.getBounds().pad(0));
      }, false);
    }
  }
};

export { resetLocation };
